import moment from 'moment'

// 异步导出查询条件转换
export const generateExportCondition = {
  input: (val) => ({
    matchValue: val,
    hidden: !val,
  }),
  'date-picker': (val) => {
    if (Array.isArray(val)) {
      // 时间段
      if (val.length === 0) {
        return {
          hidden: true,
        }
      }
      return {
        matchValue: val
          .map((item) => moment(item).format('YYYY-MM-DD HH:mm:ss'))
          .join(' - '),
      }
    }
    // 日期
    return {
      matchValue: val,
      hidden: !val,
    }
  },
  select: (val, config) => {
    const { options = {} } = config?.elConfig
    const { list, label, value } = options
    if (Array.isArray(val)) {
      // 多选
      const result = list.reduce((res, current) => {
        if (val.includes(current[value])) {
          res.push(current[label])
        }
        return res
      }, [])
      return {
        matchValue: result.length === 0 ? '全部' : result,
      }
    }

    // 单选
    const item = list.find(
      (it) => it[value] === val,
    )
    return {
      matchValue: !item ? '全部' : item[label],
    }
  },
}

export const PUBLIC_KEY_3 = 'riOJlLYKOcagUH2ZQ7e8EMaGQPx+MUpbFV33cH1VJ6e2pt7VVpaimfPSDPDX7eHFrwIDAQAB'
